import React from 'react';
// eslint-disable-next-line import/no-unresolved
import { ReactComponent as WarningIcon } from 'Assets/svg/warning-grey.svg';

const PageNotFound = () => {
  return (
    <div className="page-not-found">
      <WarningIcon />
      <div className="not-found-title">Oops!</div>
      <div className="not-found-text">
        <div>
          Something went wrong. We couldn&#39;t find what you are looking for.
        </div>
        <div>Please try after sometime.</div>
      </div>
    </div>
  );
};

export default PageNotFound;
export { PageNotFound };
